import type { Place } from "@App/types";
import { gql } from "@apollo/client";

export interface GeoSuggestQuery {
  geosuggest: Place[];
}

export const GET_GEOSUGGEST = gql`
    query geosuggest($search: String, $lat:Float, $lon:Float, $placeId: String) {
        geosuggest(search: $search, lat: $lat, lon: $lon, placeId: $placeId) {
            id
            lat
            lon
            name
            resultType
            language
            countryCode
            address {
                city
                county
                countryName: country
                postalCode: postcode
                countyCode
                state
                street
                houseNumber
            }
        }
    }
`;
